import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from './ClickOutsideDirective';
import { AutofocusDirective } from './AutofocusDirective';
import { ResizeDirective } from './ResizeDirective';
import { FixElementSizeDirective } from './FixElementSizeDirective';
import { AcvisDirective } from './DraggingDirective';
import { ContenteditableValueAccessor } from './ContentEditable';
@NgModule({
    declarations: [
        ClickOutsideDirective,
        AutofocusDirective,
        ResizeDirective,
        FixElementSizeDirective,
        AcvisDirective,
        ContenteditableValueAccessor
    ],
    imports: [],

    exports: [
        ClickOutsideDirective,
        AutofocusDirective,
        ResizeDirective,
        FixElementSizeDirective,
        AcvisDirective,
        ContenteditableValueAccessor
    ],

    providers: [
    ],
})

export class DirectiveModule { }
